import { ReactNode, lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { usePageTracking } from '@/hooks/usePageTracking';

const WhatsAppFloat = lazy(() => import('./WhatsAppFloat'));

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  usePageTracking();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background bg-pattern">
      <Header />
      <main key={location.pathname} className="pt-16 animate-fade-in">
        {children}
      </main>
      <Footer />

      <Suspense fallback={null}>
        <WhatsAppFloat />
      </Suspense>
    </div>
  );
};

export default Layout;
